import * as React from "react";
import { UitkDialogAnimationType, UitkFullscreenDialog } from "uitk-react-dialog";
import { UitkToolbar, UitkToolbarProps } from "uitk-react-toolbar";
import { LinksDialogContext } from "components/flexComponents/Links/GridView/LinkDialogContext";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import Links from "components/flexComponents/Links/Links";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { ExperienceTemplateRenderer, TemplateComponent } from "experience-template-renderer-react";
import { UitkSpacing } from "uitk-react-spacing";

interface LinkDialogProps {
  id: string;
  onDismiss: () => void;
  context: ExtendedContextStore;
  groups?: BlossomComponent[];
  templateComponents?: TemplateComponent[];
}

export const LinkDialog = (props: LinkDialogProps) => {
  const { id, onDismiss, context, groups, templateComponents } = props;
  const linksDialogContext = LinksDialogContext;

  const keyHelper = new ItemKeyHelper(`LinkDialog-${id}`);

  const dialogProps = {
    dialogShow: true,
    animation: UitkDialogAnimationType.SLIDEUP,
  };
  const toolBarAttributes: UitkToolbarProps = {
    toolbarTitle: linksDialogContext.dialogHeading,
    navigationContent: {
      navIconLabel: "Close",
      onClick: onDismiss,
    },
  };

  const linkItems = linksDialogContext.modules.map((module, index) => {
    if (module.type === "link-juice") {
      if (groups) {
        const linksJuiceModule = groups.filter((groupItem: BlossomComponent) => {
          const [element] = groupItem.getBlossomComponents();
          return element.id === module.metadata.id;
        });
        return (
          <BlossomComponents
            context={context}
            blossomComponent={linksJuiceModule[0]}
            key={`link-dialog-item-${index}`}
          />
        );
      }
      if (templateComponents) {
        const linksJuiceModule = templateComponents.filter((groupItem: TemplateComponent) => {
          /* istanbul ignore next */
          if (groupItem.children) {
            const [element] = groupItem.children;
            return element.metadata?.id === module.metadata.id;
          }
          return false;
        });
        // Asserted none null children in the filter
        return (
          <ExperienceTemplateRenderer
            templateComponents={linksJuiceModule[0].children!}
            key={`link-dialog-item-${index}`}
          />
        );
      }
    }
    return <Links key={keyHelper.next()} templateComponent={module} insideTabGroupParam />;
  });

  return (
    <UitkFullscreenDialog {...dialogProps}>
      <div>
        <UitkToolbar {...toolBarAttributes} />
      </div>
      <UitkSpacing padding={{ blockstart: "one" }} margin="one">
        <div className="LinkDialog uitk-scroll-vertical">{linkItems}</div>
      </UitkSpacing>
    </UitkFullscreenDialog>
  );
};
